import {
  ActionArm,
  ActionBrake,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionInspection,
  ActionLand,
  ActionReturn,
  ActionTakeoff,
  CameraLiveView,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
} from '@/define/commandSet/mavlink';

const commandGroups = [
  {
    name: 'Action',
    commands: [
      ActionInspection,
      ActionArm,
      ActionDisarm,
      ActionTakeoff,
      ActionGoto,
      ActionElevate,
      ActionBrake,
      ActionLand,
      ActionReturn,
    ],
  },
  {
    name: 'Camera',
    commands: [CameraLiveView],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
];

export default commandGroups;
